import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class BHQrCodeScannerService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }
}